/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flagship_Onboarding_Continue_LabelInputs */

const en_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const de_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const pt_br2_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const tr_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam et`)
};

const zh_cn2_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_hk2_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

const ko_kr2_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

const ru_ru2_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const es_419_flagship_onboarding_continue_label = /** @type {(inputs: Flagship_Onboarding_Continue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Flagship_Onboarding_Continue_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const flagship_onboarding_continue_label = /** @type {((inputs?: Flagship_Onboarding_Continue_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flagship_Onboarding_Continue_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flagship_onboarding_continue_label(inputs)
	if (locale === "de") return de_flagship_onboarding_continue_label(inputs)
	if (locale === "pt-BR") return pt_br2_flagship_onboarding_continue_label(inputs)
	if (locale === "tr") return tr_flagship_onboarding_continue_label(inputs)
	if (locale === "zh-CN") return zh_cn2_flagship_onboarding_continue_label(inputs)
	if (locale === "zh-HK") return zh_hk2_flagship_onboarding_continue_label(inputs)
	if (locale === "ko-KR") return ko_kr2_flagship_onboarding_continue_label(inputs)
	if (locale === "ru-RU") return ru_ru2_flagship_onboarding_continue_label(inputs)
	return es_419_flagship_onboarding_continue_label(inputs)
});